import {LocaleType} from '../enum/LocaleType'
import {resolveLocaleType} from './resolveLocaleType'

const languageTagAliases: Record<string, LocaleType> = {
  uk: LocaleType.Ukrainian,
  nb: LocaleType.Norwegian,
  nn: LocaleType.Norwegian,
}

export function resolveLocaleTypeFromLanguageTag(languageTag: string | undefined | null): LocaleType {
  if(!languageTag) {
    return LocaleType.English
  }
  const normalized = languageTag.trim().toLowerCase().replace('_', '-')
  if(!normalized) {
    return LocaleType.English
  }
  if(Object.values(LocaleType).includes(normalized as LocaleType)) {
    return normalized as LocaleType
  }
  const primary = normalized.split('-')[0]
  if(languageTagAliases[primary]) {
    return languageTagAliases[primary]
  }
  return resolveLocaleType(primary)
}
